// Per-tab flags for the maintenance banner. sessionStorage (not localStorage) so
// they survive the localStorage.clear() calls on logout and are scoped to a tab.
// Every access is guarded: storage can throw (private mode / blocked site data),
// and the banner must still work without it.

const FRESH_LOGIN_KEY = 'maintenance_fresh_login';
const MODAL_ACK_PREFIX = 'maintenance_modal_ack_';

const read = (key) => {
  try {
    return window.sessionStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

const write = (key, value) => {
  try {
    window.sessionStorage.setItem(key, value);
  } catch (e) {
    // ignore — the modal may show again, which is harmless
  }
};

const remove = (key) => {
  try {
    window.sessionStorage.removeItem(key);
  } catch (e) {
    // ignore
  }
};

// Set right after a successful sign-in, so the banner can show the
// "maintenance is scheduled" pop-up once to users who log in mid-countdown.
export const markFreshLogin = () => write(FRESH_LOGIN_KEY, '1');

// Returns true once per sign-in.
export const consumeFreshLogin = () => {
  const fresh = read(FRESH_LOGIN_KEY) === '1';
  if (fresh) remove(FRESH_LOGIN_KEY);
  return fresh;
};

export const isModalAcked = (key) => read(MODAL_ACK_PREFIX + key) === '1';

export const ackModal = (key) => write(MODAL_ACK_PREFIX + key, '1');
